export { default as stateFromHTML } from './stateFromHTML';